import { OpinionsResultCard } from '../../OpinionsSearch/OpinionsResultCard';
import { AccordionResultsSection } from '../../shared';
import { useJudgeAuthoredOpinions } from '../api';

interface JudgeCaseLawAuthoredProps {
  judgeId: number;
  judgeName: string;
}

export const JudgeCaseLawAuthored = ({
  judgeId,
  judgeName,
}: JudgeCaseLawAuthoredProps) => {
  const {
    data: opinionsData,
    isLoading,
    isError,
    error,
    isTokenLoading,
  } = useJudgeAuthoredOpinions(judgeId);
  const isLoadingOrToken = isLoading || isTokenLoading;
  const allOpinions = opinionsData?.results ?? [];
  const totalCount = opinionsData?.count ?? 0;

  return (
    <AccordionResultsSection
      title={`Case Law Authored by ${judgeName} (${totalCount})`}
      isLoading={isLoadingOrToken}
      isError={isError}
      error={error}
      errorLabel="Error loading authored opinions"
      results={allOpinions}
      emptyMessage={`No authored opinions found for ${judgeName}.`}
      renderCard={(opinionItem) => (
        <OpinionsResultCard opinionItem={opinionItem} />
      )}
      getKey={(opinionItem, index) => opinionItem.cluster_id ?? index}
    />
  );
};
